import { AgreementDefaultOrder } from "./api.services.classes"

export class ConformesFilter {
    offset?: number
    limit?: number
    csite_id?: number
    supplier_partner_id?: number
    common_area?: number
    portal?: string
    floor?: string
    letter?: string
    id?: number
    order?: AgreementDefaultOrder[];
}